export default __webpack_public_path__ + "static/media/Pabellon_del_Arte_Zagreb_Croacia_2014-04-20_DD_05.15e8d096.jpg";